import * as React from 'react';

import type { ProgramAdmissionDeadlines } from 'bundles/degree-description/types';

export type DegreeDescriptionPageAdmissionDeadlinesContextType = {
  programAdmissionDeadlinesData: ProgramAdmissionDeadlines;
};

export const DegreeDescriptionPageAdmissionDeadlinesContext = React.createContext<
  DegreeDescriptionPageAdmissionDeadlinesContextType | undefined
>(undefined);

export const useDegreeDescriptionPageAdmissionDeadlinesData = () => {
  const context = React.useContext(DegreeDescriptionPageAdmissionDeadlinesContext);
  if (!context)
    throw new Error(
      'useDegreeDescriptionPageAdmissionDeadlinesData was used outside of DegreeDescriptionPageAdmissionDeadlinesContext'
    );
  return context;
};

export default DegreeDescriptionPageAdmissionDeadlinesContext;
